// Family Brain logo (brain + sparkles icon, no text). Use this everywhere
// instead of the generic Sparkles-in-coral-square placeholder.
export default function BrandLogo({ size = 40, className = "", rounded = true }) {
  return (
    <img
      src="/brand/icon.png"
      alt="Family Brain"
      width={size}
      height={size}
      className={`${rounded ? "rounded-2xl" : ""} object-contain bg-app ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-logo"
    />
  );
}
